/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import AlgoliaSearchBox from '../components/AlgoliaSearchBox';
import Navigation from '../components/Navigation';
import NavigationDrawer from '../components/NavigationDrawer';
import AccountInfoHolder from '../components/admin/AccountInfoHolder';
import AccountMergeInterface from '../components/admin/AccountMergeInterface';
import AcquiredContentInterface from '../components/admin/AcquiredContentInterface';
import { AlgoliaMemberSearchBox } from '../application/javascripts/react_components/search/algolia_member_search_box';
import { BranchAppText } from '../application/javascripts/react_components/branch/branch_app_text';
import BulkTrailEdit from '../pages/BulkTrailEdit';
import { ConnectAppleButton } from '../application/javascripts/react_components/connect_apple_button';
import { ConnectGoogleButton } from '../application/javascripts/react_components/connect_google_button';
import { ContributeTrailApp } from '../application/javascripts/react_components/contribute/contribute_trail_app';
import { Converter } from '../application/javascripts/react_components/converter/converter';
import { ConverterSuccess } from '../application/javascripts/react_components/converter/converter_success';
import { FullscreenSearchApp } from '../application/javascripts/react_components/search/fullscreen/search_app';
import ForgotPasswordForm from '../components/forms/ForgotPasswordForm';
import { GiftCouponList } from '../application/javascripts/react_components/gift/gift_coupon_list';
import { LanguageMenuDropdown } from '../application/javascripts/react_components/language_menu_dropdown';
import { LifelineSearchInterface } from '../application/javascripts/react_components/admin/lifeline_search_interface';
import Lightbox from '../components/shared/Lightbox';
import RemoteLightbox from '../components/shared/RemoteLightbox';
import PhotoCreditLink from '../components/shared/PhotoCreditLink';
import PhotoForTrailOrTrackCollection from '../components/profile/PhotoForTrailOrTrackCollection';
import { ListDisplayContainer } from '../application/javascripts/react_components/list_display_container';
import { LocationMergeInterface } from '../application/javascripts/react_components/admin/location_merge_interface';
import { MapElevationPaneWidget } from '../application/javascripts/react_components/search/fullscreen/map_elevation_pane_widget';
import { FullscreenMapElevationPane } from '../application/javascripts/react_components/search/fullscreen/map_elevation_pane';
import MapStarRating from '../components/forms/MapStarRating';
import MobileExploreMapSwitch from '../components/MobileExploreMapSwitch';
import { MobileRoadblock } from '../application/javascripts/react_components/branch/mobile_roadblock';
import PasswordResetForm from '../components/forms/PasswordResetForm';
import { PhotoAdminTool } from '../application/javascripts/react_components/admin/photo_admin_tool';
import { PhotoCaption } from '../application/javascripts/react_components/photos/photo_caption';
import { PhotoForTrailOrTrack } from '../application/javascripts/react_components/photos/photo_for_trail_or_track';
import { PhotoPopup } from '../application/javascripts/react_components/maps/map_abstraction/photo_popup';
import PhotosMenuItem from '../components/TrailDetails/PhotosMenuItem';
import { PrintMap } from '../application/javascripts/react_components/print/print_map';
import { ProfileEditForm } from '../application/javascripts/react_components/profile_edit_form';
import ProfileSlidingTabs from '../components/profile/ProfileSlidingTabs';
import CreateListPopupButton from '../components/profile/CreateListPopupButton';
import { PurchaseGiftForm } from '../application/javascripts/react_components/gift/purchase_gift_form';
import { QuoteRotator } from '../application/javascripts/react_components/quote_rotator';
import RecordingSearchInterface from '../components/admin/RecordingSearchInterface';
import { RoadblockedAnchor } from '../application/javascripts/react_components/branch/roadblocked_anchor';
import { StatusUpdateItem } from '../application/javascripts/react_components/status_update/status_update_item';
import { StatusUpdateResults } from '../application/javascripts/react_components/status_update/status_update_results';
import { TrailFeeds } from '../application/javascripts/react_components/feeds/trail_feeds';
import { TrailRatingStars } from '../application/javascripts/react_components/trail_rating_stars';
import { TranslationEditInterface } from '../application/javascripts/react_components/admin/translation_edit_interface';
import CouponManager from '../components/admin/CouponManager';
import BannerManager from '../components/admin/BannerManager';
import { UserListItem } from '../application/javascripts/react_components/user_list_item';
import { UserStatsDashboard } from '../application/javascripts/react_components/stats/user_stats_dashboard';
import WeatherConditions from '../components/TrailDetails/WeatherConditions';

const ReactRailsUJS = require('react_ujs');

const context = {
  AccountInfoHolder,
  AccountMergeInterface,
  AcquiredContentInterface,
  AlgoliaMemberSearchBox,
  AlgoliaSearchBox,
  BranchAppText,
  BannerManager,
  BulkTrailEdit,
  ConnectAppleButton,
  ConnectGoogleButton,
  ContributeTrailApp,
  Converter,
  ConverterSuccess,
  CouponManager,
  FullscreenSearchApp,
  ForgotPasswordForm,
  GiftCouponList,
  LanguageMenuDropdown,
  LifelineSearchInterface,
  Lightbox,
  ListDisplayContainer,
  LocationMergeInterface,
  MapElevationPaneWidget,
  FullscreenMapElevationPane,
  MapStarRating,
  MobileExploreMapSwitch,
  MobileRoadblock,
  Navigation,
  NavigationDrawer,
  PasswordResetForm,
  PhotoAdminTool,
  PhotoCaption,
  PhotoForTrailOrTrack,
  PhotoPopup,
  PrintMap,
  ProfileEditForm,
  ProfileSlidingTabs,
  CreateListPopupButton,
  PurchaseGiftForm,
  PhotoCreditLink,
  PhotosMenuItem,
  PhotoForTrailOrTrackCollection,
  QuoteRotator,
  RecordingSearchInterface,
  RemoteLightbox,
  RoadblockedAnchor,
  StatusUpdateItem,
  StatusUpdateResults,
  TrailFeeds,
  TrailRatingStars,
  TranslationEditInterface,
  UserListItem,
  UserStatsDashboard,
  WeatherConditions
};
ReactRailsUJS.getConstructor = className => {
  return context[className];
};
